export const IMAGE_DEVICE_SIZES = [640, 828, 1200] as const;

export const IMAGE_SIZES = [48, 64, 96, 128, 256, 384] as const;

export const IMAGE_QUALITIES = [60, 75] as const;

export const IMAGE_WIDTHS: readonly number[] = [
  ...IMAGE_SIZES,
  ...IMAGE_DEVICE_SIZES,
];
